import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import HsCodeRemarkService from "../../Services/HsCodeRemarkService";
import MarketplaceAdditionalService from "../../Services/MarketplaceAdditionalService";
import SystemSettingsCard from "./SystemSettingsCard";
import DiscountSettings from "./DiscountSettings";

export const MarketplaceAdditionalCharges = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState();
  const history = useHistory();

  const initialValues = {
    caf: "",
    duty_tax_additional_charge: "",
    duty_tax_freight_per: "",
    duty_tax_insurance_per: "",
    local_vat_per: "",
    min_duty_tax: "",
    over_weight_charge: "",
    over_weight_max: "",
  };

  const validationSchema = Yup.object().shape({
    caf: Yup.string().required("Required"),
    duty_tax_additional_charge: Yup.string().required("Required"),
    duty_tax_freight_per: Yup.string().required("Required"),
    duty_tax_insurance_per: Yup.string().required("Required"),
    local_vat_per: Yup.string().required("Required"),
    min_duty_tax: Yup.string().required("Required"),
    over_weight_charge: Yup.string().required("Required"),
    over_weight_max: Yup.string().required("Required"),
  });

  const getData = () => {
    setLoader(true);
    MarketplaceAdditionalService.getMarketplaceadditionalcharges().then(
      (res) => {
        if (res.status) {
          setData(res.data);
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoader(true);
      values = { ...values };
      MarketplaceAdditionalService.updateMarketplaceadditionalcharges(values)
        .then((res) => {
          if (res.status) {
            toast.success(res.msg);
            setLoader(false);
            getData();
          } else {
            setLoader(false);
            toast.error(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    setValues,
  } = formik;

  useEffect(() => {
    if (data) {
      setValues(data);
    }
  }, [data]);

  return (
    <>
    <div className="row">
    <div className="col-lg-6">
      <div className="card">
        <div className="card-body">
          <form
            className="control-form"
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            {/* Charges  */}
            <div className="row">
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">Currency Adjustment Factor %</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.caf && errors.caf ? " is-invalid" : "")
                      }
                      value={values?.caf}
                      name="caf"
                      placeholder="Enter caf"
                      {...getFieldProps("caf")}
                    />
                    {touched.caf && errors.caf ? (
                      <div className="text-danger">{errors.caf}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">
                      Duty And Tax Additional Charge (AED)
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.duty_tax_additional_charge &&
                        errors.duty_tax_additional_charge
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.duty_tax_additional_charge}
                      name="duty_tax_additional_charge"
                      placeholder="Enter duty tax additional_charge"
                      {...getFieldProps("duty_tax_additional_charge")}
                    />
                    {touched.duty_tax_additional_charge &&
                    errors.duty_tax_additional_charge ? (
                      <div className="text-danger">
                        {errors.duty_tax_additional_charge}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    {" "}
                    <label className="form-label">
                    Duty Tax Freight %
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.duty_tax_freight_per &&
                        errors.duty_tax_freight_per
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.duty_tax_freight_per}
                      name="duty_tax_freight_per"
                      placeholder="Enter duty tax freight per"
                      {...getFieldProps("duty_tax_freight_per")}
                    />
                    {touched.duty_tax_freight_per &&
                    errors.duty_tax_freight_per ? (
                      <div className="text-danger">
                        {errors.duty_tax_freight_per}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">
                    Duty Tax Insurance %
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.duty_tax_insurance_per &&
                        errors.duty_tax_insurance_per
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.duty_tax_insurance_per}
                      name="duty_tax_insurance_per"
                      placeholder="Enter duty tax insurance per"
                      {...getFieldProps("duty_tax_insurance_per")}
                    />
                    {touched.duty_tax_insurance_per &&
                    errors.duty_tax_insurance_per ? (
                      <div className="text-danger">
                        {errors.duty_tax_insurance_per}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">Local Shipment Vat %</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.local_vat_per && errors.local_vat_per
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.local_vat_per}
                      name="local_vat_per"
                      placeholder="Enter Local Vat Per"
                      {...getFieldProps("local_vat_per")}
                    />
                    {touched.local_vat_per && errors.local_vat_per ? (
                      <div className="text-danger">{errors.local_vat_per}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">Min Duty Tax Amount (AED)</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.min_duty_tax && errors.min_duty_tax
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.min_duty_tax}
                      name="min_duty_tax"
                      placeholder="Enter min duty tax"
                      {...getFieldProps("min_duty_tax")}
                    />
                    {touched.min_duty_tax && errors.min_duty_tax ? (
                      <div className="text-danger">{errors.min_duty_tax}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">Over Weight Charge (AED)</label>
                  </div>
                  <div className="col-6">
                    {" "}
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.over_weight_charge && errors.over_weight_charge
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.over_weight_charge}
                      name="over_weight_charge"
                      placeholder="Enter over weight charge"
                      {...getFieldProps("over_weight_charge")}
                    />
                    {touched.over_weight_charge && errors.over_weight_charge ? (
                      <div className="text-danger">
                        {errors.over_weight_charge}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label">Over Weight Max (KG)</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.over_weight_max && errors.over_weight_max
                          ? " is-invalid"
                          : "")
                      }
                      value={values?.over_weight_max}
                      name="over_weight_max"
                      placeholder="Enter over weight charge"
                      {...getFieldProps("over_weight_max")}
                    />
                    {touched.over_weight_max && errors.over_weight_max ? (
                      <div className="text-danger">
                        {errors.over_weight_max}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-3 d-flex justify-content-between">
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                type="submit"
              >
                Update
              </button>
            </div>
          </form>
          <Loader isShow={loader} />
        </div>
      </div>
    </div>
    <SystemSettingsCard />
    </div>
    <div className="row mt-4">
      <div className="col-lg-12">
        <DiscountSettings />
      </div>
    </div>
    </>
  );
};
